import { useState } from "../../../__compat__/react/main.entry.mjs.mjs";
import { addWeeks, subWeeks, addMonths, subMonths, addDays, subDays, startOfWeek, endOfWeek, isSameDay, } from "../../../__compat__/date-fns/main.entry.mjs.mjs";
const keyMappings = {
    Home: startOfWeek,
    End: endOfWeek,
    PageUp: (date) => subMonths(date, 1),
    PageDown: (date) => addMonths(date, 1),
    ArrowUp: (date) => subWeeks(date, 1),
    ArrowDown: (date) => addWeeks(date, 1),
    ArrowLeft: (date) => subDays(date, 1),
    ArrowRight: (date) => addDays(date, 1),
};
export function useCalendarFocus() {
    const [focus, setFocus] = useState(null);
    const handleFocus = (date, event) => {
        if (event.key in keyMappings) {
            const operation = keyMappings[event.key];
            event.preventDefault();
            setFocus(operation(date));
        }
    };
    const clearFocus = () => setFocus(null);
    const getFocusProps = (date) => ({
        focused: focus !== null && isSameDay(focus, date),
    });
    return {
        focus,
        handleFocus,
        clearFocus,
        setFocus,
        getFocusProps,
    };
}
//# sourceMappingURL=useCalendarFocus.mjs.mjs.map